import { Component, OnInit, Inject, ViewChild } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatStepper } from '@angular/material/stepper'
import { Channel } from '@tokeet-frontend/tv3-platform'

@Component({
  selector: 'app-connect-expedia-wizard',
  templateUrl: './connect-expedia-wizard.component.html',
  styleUrls: ['./connect-expedia-wizard.component.scss'],
  host: {
    class: 'modal-content',
  },
})
export class ConnectExpediaWizardComponent implements OnInit {
  @ViewChild(MatStepper) stepper: MatStepper

  get channel() {
    return this.data.channel
  }

  constructor(
    public dialogRef: MatDialogRef<ConnectExpediaWizardComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { channel: Channel }
  ) {}

  ngOnInit(): void {}

  close() {
    this.dialogRef.close()
  }

  onChannel() {
    this.dialogRef.close('channel')
  }
}
